<div
  class="wrapper flex vcenter"
  role="button"
  tabindex="0"
  (click)="onCheck()"
  (keydown.enter)="onCheck()"
  (keydown.space)="onCheck(); $event.preventDefault()"
>
  <div
    class="outter-box"
    [class.toggled-on]="checked"
  >
    @if (checked) {
      <div class="inner-box"></div>
    }
  </div>
  <div>
    <ng-content></ng-content>
  </div>
</div>
